const constant=a=>()=>a;export default constant;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/axis/utils/constant.js
// module id = null
// module chunks = 